// product-detail-card-list

function switchProductList(listId) {
  const lists = document.querySelectorAll('.pdc-list[data-list-id]')
  let activeList = null

  for (const list of lists) {
    if (list.dataset.listId === listId) {
      list.style.display = 'block'
      activeList = list
    } else {
      list.style.display = 'none'
    }
  }

  return activeList
}

function getStickyHeight(selector, includeHidden = false) {
  const element = document.querySelector(selector)
  if (!element) return 0

  const styles = window.getComputedStyle(element)
  if (styles.position !== 'sticky' && styles.position !== 'fixed') return 0

  const rect = element.getBoundingClientRect()
  if (includeHidden) return rect.height
  if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 0

  return rect.height
}

function getProductGridScrollOffset(gridTop) {
  const filtersHeight = document.querySelector('.tr-filters')?.getBoundingClientRect().height || 0
  const visibleHeaderHeight =
    getStickyHeight('.new-announcement-bar__wrapper.is-sticky') +
    getStickyHeight('.main-nav__wrapper.is-sticky')
  const visibleOffset = visibleHeaderHeight + filtersHeight
  const isMobile = window.matchMedia('(max-width: 767px)').matches
  const willScrollUp = gridTop - visibleOffset < window.scrollY
  const reserveHiddenHeader = isMobile && willScrollUp

  if (!reserveHiddenHeader) return visibleOffset

  return (
    getStickyHeight('.new-announcement-bar__wrapper.is-sticky', true) +
    getStickyHeight('.main-nav__wrapper.is-sticky', true) +
    filtersHeight
  )
}

function scrollToProductGrid(list) {
  const grid = list?.querySelector('.tr-grid')
  if (!grid) return

  const gridTop = grid.getBoundingClientRect().top + window.scrollY
  const stickyOffset = getProductGridScrollOffset(gridTop)
  const targetTop = gridTop - stickyOffset
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  window.scrollTo({
    top: Math.max(0, targetTop),
    behavior: reducedMotion ? 'auto' : 'smooth',
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const listSelectors = document.querySelectorAll('.js-pdc-list-selector')
  if (listSelectors.length > 0) {
    for (const selector of listSelectors) {
      selector.addEventListener('change', (event) => {
        const listId = event.target.value
        const activeList = switchProductList(listId)
        window.requestAnimationFrame(() => scrollToProductGrid(activeList))
      })
    }
  }

  const imageButtons = document.querySelectorAll('.js-pdc-image')
  if (imageButtons.length > 0) {
    for (const imageButton of imageButtons) {
      imageButton.addEventListener('click', (event) => {
        event.preventDefault()
        if (typeof openQuickAddModal === 'function')
          openQuickAddModal(imageButton.dataset.productHandle)
      })
    }
  }
})
